import { render, staticRenderFns } from "./QrCodeDetails.vue?vue&type=template&id=38b8fc89"
import script from "./QrCodeDetails.vue?vue&type=script&lang=js"
export * from "./QrCodeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports